import router from '@/router';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

export interface DialogFormState {
  isOpenDialog: boolean;
  nextRoute: string;
}

export const state: DialogFormState = {
  isOpenDialog: false,
  nextRoute: ''
};

export const getters: GetterTree<DialogFormState, any> = {};

export const mutations: MutationTree<DialogFormState> = {
  setIsOpenDialog: (state: DialogFormState, isOpen: boolean) => {
    state.isOpenDialog = isOpen;
  },
  setNextRoute: (state: DialogFormState, route: string) => {
    state.nextRoute = route;
  },
  setConfigDialog: (state, payload) => {
    const isOpenDialog = payload.isOpen ?? !state.isOpenDialog;
    state.isOpenDialog = isOpenDialog;
    if (payload.route) {
      state.nextRoute = payload.route;
    }
  }
};

const actions: ActionTree<DialogFormState, any> = {
  exitWithoutSave: ({ commit }) => {
    router.push({ name: state.nextRoute });
    commit('setConfigDialog', { isOpen: false });
  }
};

export const dialogForm: Module<DialogFormState, any> = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
